import React from 'react';
import { StringWms } from '../../../../assets/ts/StringWms.ts';
import axios from 'axios';

//component
import WmsButton from '../WmsButton/WmsButton.jsx';
import WmsCollapse from '../WmsCollapse/WmsCollapse.jsx';
import WmsFile from '../WmsFile/WmsFile.jsx';
import WmsFormGrid from '../WmsFormGrid/WmsFormGrid.jsx';
import WmsModel from '../WmsModel/WmsModel.jsx';
import WmsDropdown from '../WmsDropdown/WmsDropdown.jsx';
import WmsDropdownList from '../WmsDropdownList/WmsDropdownList.jsx';
import './AttachDocuments.scss';

import * as GlobalService from '../../global_services';
import * as attachDocumentsServices from './attachDocuments.service.jsx';
import { kendo } from "./../../global_variable_service.jsx";
import MagnifyImage from '../MagnifyImage/magnify-image.tsx';
var dragTimer = null;

export class AttachDocuments extends React.PureComponent {

    constructor(props) {

        super(props);

        this.translate = window.translate;
        this.GetImageAxiosSource = null;
        this.customLabels = GlobalService.getCustomLabels();
        this.attachInProgress = false;
        this._isMounted = false;
        let gridHeaders = StringWms.convertSringToOption(this.translate('AttachFile_GridHeaders'));
        let customers = GlobalService.getCustomerList(false);
        this.state = {
            selector: "attachDocument",
            optionsCustomer: GlobalService.getCustomerList(false),
            selectedCustomerId: (customers.length ? customers[0].id : 0),
            batchOrderid: 0,
            batchOrderOptions: [],
            atttachGridData: null,
            selectedAttachItem: null,
            selectedFileData: {},
            selectedFile: 0,
            gifAttachFile: false,
            gifRemoveFile: false,
            acticveDoc: false,
            isSelectedImage: false,
            selectedImage: null,
            gridColumns: [
                {
                    field: "DocName",
                    title: gridHeaders[1].description,
                    template: '#if(DownloadUri != null) {# <a href="javascript:void(0);" class="download-file" download-uri="#=DownloadUri#" doc-name="#=DocName#"  download>#=DocName#</a> #} else{# <span>#=DocName#</span> #}#',
                    width: 100
                }, {
                    field: "DocLength",
                    title: gridHeaders[2].description,
                    template: "#= DocLength != null ?  (DocLength > 1048576 ? (DocLength / 1048576).toFixed(2) + ' MB' : (DocLength / 1024).toFixed(2) + ' KB' ): ''#",
                    width: 100
                }, {
                    field: "AttachedDate",
                    title: gridHeaders[3].description,
                    template: "#= AttachedDate != null ? kendo.toString(kendo.parseDate(AttachedDate), 'MM/dd/yyyy hh:mm:ss tt')  : '' # #= AttachedBy  ? ' by ' + AttachedBy : ''#",
                    width: 200
                }, {
                    field: "RemovedDate",
                    title: gridHeaders[4].description,
                    template: "#= RemovedDate != null ? kendo.toString(kendo.parseDate(RemovedDate), 'MM/dd/yyyy hh:mm:ss tt') : '' #  #= RemovedBy  ? ' by ' + RemovedBy : ''#",
                    width: 200
                }
            ],
            gridSchema: {
                data: [],
                schema: {
                    model: {
                        fields: {
                            Class: {
                                type: "string"
                            },
                            DocName: {
                                type: "string"
                            },
                            DocLength: {
                                type: "number",
                                editable: false
                            },
                            AttachedDate: {
                                type: "date"
                            },
                            RemovedDate: {
                                type: "date"
                            }
                        }
                    }
                }
            }
        };
    }
    UNSAFE_componentWillMount() {
        let self = this;
        $(document).off("click", ".download-file");
        $(document).off("dragover", "#" + this.props.windowId + "attachDocuments .wms-collapsible-content");
        $(document).off("dragleave", "#" + this.props.windowId + "attachDocuments .wms-collapsible-content");
        $(document).off("drop", "#" + this.props.windowId + "attachDocuments .wms-collapsible-content");
    }
    componentDidMount() {
        this._isMounted = true;
        let self = this;
        // $(".download-file").off("click");
        $(document).on("click", ".download-file", attachDownloadEvent);
        function attachDownloadEvent() {
            self.downloadFile($(this).attr('download-uri'), $(this).attr('doc-name'));
        }
        if (this.props.isOpenAttachDoc == true && !this.props.sharedAttachObj.isOrderAttachBatch) {
            this.getAttachDocsInfo(this.props.sharedAttachObj.getAttachedDocsInfoMethod, this.props.sharedAttachObj.getAttachedDocsInfoUrl, this.props.sharedAttachObj.getAttachedDocsInfoPayload);
        }

        if(this.props.isDragAndDrop){
            // Add dropzone event listeners
            $(document).on("dragover", "#" + this.props.windowId + "attachDocuments .wms-collapsible-content", function(e) {
                e.preventDefault();
                e.stopPropagation();
                $("#dropzone").show();
                window.clearTimeout(dragTimer);
            });
            $(document).on("dragleave", "#" + this.props.windowId + "attachDocuments .wms-collapsible-content", function(e) {
                e.preventDefault();
                e.stopPropagation();
                dragTimer = window.setTimeout(function() {
                    $("#dropzone").hide();
                }, 25);
            });
            $(document).on("drop", "#" + this.props.windowId + "attachDocuments .wms-collapsible-content", this.handleDrop);
        }
        // document.addEventListener("EventOrderChangedRemove", function handler(e) {
        //     console.log("Remove lister call React AttachDocument");
        //     // alert("remove from attach file");
        //     $(document).off("click", ".download-file", self.attachDownloadEvent);
        //     e.currentTarget.removeEventListener(e.type, handler);
        //     /* whatever */
        // });

    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getAttachDocsInfo = (method, param_url, param_payload) => {
        this.setState({
            atttachGridData: [],
            selectedFileData: {}
        });
        kendo.ui.progress($('#' + this.props.windowId + 'attachDocuments'), true);
        attachDocumentsServices.getAttachedDocsInfo(method, param_url, param_payload).then((response) => {
            if (typeof response != 'undefined' && (response.status == 200 || response.status == 204)) {
                this.setState({ atttachGridData: this.addActiveRemoveClass(response.data) }, () => {
                });
            }
        }).finally(() => {
            kendo.ui.progress($('#' + this.props.windowId + 'attachDocuments'), false);
        });
    }

    getAttachDocumentUrl = (fileName) => {
        if (this.props.sharedAttachObj.isOrderAttachBatch) {
            var selectedBatchObj = this.state.batchOrderOptions.find(obj => obj.BatchOrderId == this.state.batchOrderid);
            return this.props.sharedAttachObj.attachdocumentUrl + selectedBatchObj.BatchUri + '/filesummaries' + '&fileName=' + fileName;
        }
        return this.props.sharedAttachObj.attachdocumentUrl + '&fileName=' + fileName;
    }

    refreshAttachedDocs = () => {
        if (this.props.sharedAttachObj.isOrderAttachBatch) {
            var selectedBatchObj = this.state.batchOrderOptions.find(obj => obj.BatchOrderId == this.state.batchOrderid);
            var url = this.props.sharedAttachObj.getAttachedDocsInfoUrl + selectedBatchObj.BatchUri;
            this.getAttachDocsInfo(this.props.sharedAttachObj.getAttachedDocsInfoMethod, url, {});
        } else {
            this.getAttachDocsInfo(this.props.sharedAttachObj.getAttachedDocsInfoMethod, this.props.sharedAttachObj.getAttachedDocsInfoUrl, this.props.sharedAttachObj.getAttachedDocsInfoPayload);
        }
    }

    sanitizeFileName = (fileName) => {
        if (!fileName) {
            return fileName;
        }
        return fileName.replace(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, "-");
    }

    notifyAttachFileFailure = (file) => {
        const fileName = file && file.fileName ? file.fileName : '';
        GlobalService.notification(
            'error',
            this.translate('Label_AttachedDoc_Error').replace('%file%', fileName)
        );
    }

    readFileContents = (fileObj) => {
        if (fileObj.FileContents) {
            return Promise.resolve(fileObj);
        }
        if (!fileObj.file) {
            return Promise.reject(new Error('No file contents'));
        }
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const bytes = new Uint8Array(event.target.result);
                resolve({
                    ...fileObj,
                    FileContents: bytes,
                    FileSize: bytes.length
                });
            };
            reader.onerror = () => {
                reject(reader.error || new Error('Failed to read file'));
            };
            reader.readAsArrayBuffer(fileObj.file);
        });
    }

    attachFiles = (files) => {
        if (this.attachInProgress || !files || files.length === 0) {
            return;
        }

        this.attachInProgress = true;
        this.setState({ gifAttachFile: true });
        let uploadedCount = 0;

        const completeBatch = () => {
            this.attachInProgress = false;
            if (!this._isMounted) {
                return;
            }
            if (uploadedCount > 0) {
                this.refreshAttachedDocs();
            }
            this.setState({ gifAttachFile: false, selectedFileData: {} });
        };

        const uploadNext = (index) => {
            if (!this._isMounted) {
                this.attachInProgress = false;
                return;
            }
            if (index >= files.length) {
                completeBatch();
                return;
            }

            const file = files[index];
            if (file.FileSize >= 8388608) {
                const fileName = file && file.fileName ? file.fileName : '';
                GlobalService.notification(
                    'warning',
                    this.translate('Label_LargeFileUpload_Error').replace('%file%', fileName)
                );
                uploadNext(index + 1);
                return;
            }

            this.readFileContents(file)
                .then((readyFile) => attachDocumentsServices.attachDocument(
                    this.getAttachDocumentUrl(readyFile.fileName),
                    readyFile.FileContents,
                    readyFile.ContentType
                ))
                .then(() => {
                    uploadedCount += 1;
                    uploadNext(index + 1);
                })
                .catch(() => {
                    this.notifyAttachFileFailure(file);
                    uploadNext(index + 1);
                });
        };

        uploadNext(0);
    }

    downloadFile = (uri, fileName) => {
        uri = uri.replace(/%27%27/g, "'");
        var getAttachDocUrl = '/WebUI/Shared/GlobalServices/GetAttachedDoc';
        if (this.props.sharedAttachObj.isReceipt == true){
            getAttachDocUrl = '/WebUI/Shared/GlobalServices/GetReceiptAttachedDoc';
        }else if (this.props.sharedAttachObj.isInventory == true){
            getAttachDocUrl = '/WebUI/Shared/GlobalServices/GetReceiptAttachedDoc';
        }else if (this.props.sharedAttachObj.isOrder == true){
            getAttachDocUrl = '/WebUI/Shared/GlobalServices/GetOrderAttachedDoc';
        }
        attachDocumentsServices.getAttachedDoc(getAttachDocUrl, uri).then((response) => {
            var headers = response.headers;
            GlobalService.downloadFileBaseOnContentType(response.data, headers['content-type'], fileName, true);
        }).finally(() => {
            // this.setState({ gifAttachFile: false });
        });

    }

    addActiveRemoveClass = (param_attachedDocsData) => {
        let combinedArray = [];
        for (let x = 0; x < param_attachedDocsData.length; x++) {
            if (param_attachedDocsData[x].RemovedBy != "" && param_attachedDocsData[x].RemovedDate != null) {
                param_attachedDocsData[x].Class = "Removed";
            } else {
                param_attachedDocsData[x].Class = "Active";
            }
            combinedArray.push(param_attachedDocsData[x]);
        }
        return combinedArray;
    }

    handleFileChange = (param_fileobj) => {
        const files = (Array.isArray(param_fileobj) ? param_fileobj : [param_fileobj]).map((file) => {
            return {
                ...file,
                fileName: this.sanitizeFileName(file.fileName)
            };
        });
        this.setState({ selectedFileData: files[files.length - 1] || {} }, () => {
            this.attachFiles(files);
        });
    }

    handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if(this.props.sharedAttachObj.isOrderAttachBatch && !(this.state.selectedCustomerId && this.state.batchOrderid)){
            GlobalService.notification('warning', this.translate('Label_Select_Customer_And_Batch'));
            $("#dropzone").hide();
            return;
        }
        $("#dropzone").hide();
        if (this.attachInProgress || this.state.gifAttachFile) {
            return;
        }

        const files = e.originalEvent.dataTransfer.files;
        if (files.length > 0) {
            this.handleFileChange(Array.from(files).map((file) => ({
                fileName: file.name,
                FileSize: file.size,
                file: file,
                ContentType: file.type
            })));
        }
    }

    handleOptionsChange = (e) => {

        this.setState({ [e.target.name]: e.target.value });
        if(e.target.name == "batchOrderid" && e.target.value){
            var selectedBatchObj =this.state.batchOrderOptions.find( obj => obj.BatchOrderId == e.target.value);
            var url = this.props.sharedAttachObj.getAttachedDocsInfoUrl + selectedBatchObj.BatchUri
            this.getAttachDocsInfo(this.props.sharedAttachObj.getAttachedDocsInfoMethod, url, {});
        }else{
            this.setState({
                atttachGridData: [],
                selectedFileData: {},
                BatchOrderId: 0
            });
        }
    }

    isImageFile = (fileName) => {
        if (!fileName) return false;
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
        const fileExtension = fileName.toLowerCase().substring(fileName.lastIndexOf('.'));
        return imageExtensions.includes(fileExtension);
    }

    getImagePreview = (uri, fileName) => {
        kendo.ui.progress($('#' + this.props.windowId + "image-preview-wrapper"), true);
        if (this.GetImageAxiosSource) {
            this.GetImageAxiosSource.cancel();
            this.GetImageAxiosSource = null;
        }
        this.GetImageAxiosSource = axios.CancelToken.source();
        uri = uri.replace(/%27%27/g, "'");
        var getAttachDocUrl = '/WebUI/Shared/GlobalServices/GetAttachedDoc';
        if (this.props.sharedAttachObj.isReceipt == true){
            getAttachDocUrl = '/WebUI/Shared/GlobalServices/GetReceiptAttachedDoc';
        }else if (this.props.sharedAttachObj.isInventory == true){
            getAttachDocUrl = '/WebUI/Shared/GlobalServices/GetReceiptAttachedDoc';
        }else if (this.props.sharedAttachObj.isOrder == true){
            getAttachDocUrl = '/WebUI/Shared/GlobalServices/GetOrderAttachedDoc';
        }
        attachDocumentsServices.getAttachedDoc(getAttachDocUrl, uri, this.GetImageAxiosSource.token).then((response) => {
            var headers = response.headers;
            var blob = new Blob([response.data], { "type": headers['content-type']});
            const imageUrl = URL.createObjectURL(blob);
            this.setState({ selectedImage: imageUrl });
            kendo.ui.progress($('#' + this.props.windowId + "image-preview-wrapper"), false);
        }).catch((error) => {
            console.log("Promise.all catch",  error);
        });
    }

    selectAttachGrid = () => {
        let grid = $("#" + this.props.windowId + "gridAttachedDocs").data("kendoGrid");
        let selected = [];
        let acticveDoc = false;
        $.map(grid.select(), (item) => {
            let selectItem = grid.dataItem(item);
            if (selectItem.RemovedDate == null && selectItem.RemovedBy == "") {
                acticveDoc = true;
            } else {
                acticveDoc = false;
            }
            selected.push(selectItem);
        });

        const isImage = selected.length > 0 ? this.isImageFile(selected[0].DocName) : false;
        let selectedImage = null;

        if (isImage && selected.length > 0 && selected[0].RemovedDate == null) {
            this.getImagePreview(selected[0].DownloadUri, selected[0].DocName);
        } else {
            this.setState({ selectedImage: null });
        }

        this.setState({
            acticveDoc: acticveDoc,
            selectedAttachItem: selected[0],
            selectedFile: selected.length,
            isSelectedImage: isImage
        });
    }

    eventClickRemoveDoc = () => {

        this.setState({ gifRemoveFile: true });

        var uri = this.state.selectedAttachItem.DownloadUri;
        var removeAttachDocUrl = this.props.sharedAttachObj.removeAttachDocUrl;
        var payloadData;
        if (this.props.sharedAttachObj.isAssembly){
            payloadData = {
                assemblyFileUri: uri,
                receiverUri: this.props.sharedAttachObj.uri
            };
        }
        else if (this.props.sharedAttachObj.isReceipt == true) {
            payloadData = {
                receiverFileUri: uri,
                receiverUri: this.props.sharedAttachObj.uri
            };
        } else if (this.props.sharedAttachObj.isInventory == true) {
            payloadData = {
                receiveItemFileUri: uri,
                fileSummariesUri: this.props.sharedAttachObj.fileSummariesUri,
            };
        } else if(this.props.sharedAttachObj.isOrderAttachBatch){
            var selectedBatchObj =this.state.batchOrderOptions.find( obj => obj.BatchOrderId == this.state.batchOrderid);
            // “/WebUI/Shipping/Orders/DeleteBatchAttachedDoc?batchFileUri={batchFileUri}&batchUri={batchUri}”
            removeAttachDocUrl = removeAttachDocUrl + uri + '&batchUri='+selectedBatchObj.BatchUri;
        }else {
            payloadData = {
                orderFileUri: uri,
                orderUri: this.props.sharedAttachObj.uri
            };
        }

        attachDocumentsServices.removeAttachedDoc(
            removeAttachDocUrl,
            payloadData
        ).then((response) => {
            if (typeof response != 'undefined' && response.status == 200) {

                this.setState({
                    atttachGridData: this.addActiveRemoveClass(response.data),
                    selectedFile: 0,
                    acticveDoc: false
                });
                GlobalService.notification('success', this.translate('Label_AttachedDoc_Removed_Success'));

            }

        }).finally(() => {
            this.setState({ gifRemoveFile: false });
        });
    }
    batchOptionBound = (event) => {
        this.setState({ batchOrderOptions: event.sender.dataSource._data });
    }

    onOpenModelFunc = () => {
        if (this.props.isDefaultMaximise) {
            var winObject = $("#" + this.props.windowId + "attachDocuments").data("kendoWindow");
            winObject.maximize();
        }
    }
    render() {
        var selectedCustomerId = this.state.selectedCustomerId;
        return (
            <WmsModel
                id={this.props.windowId + 'attachDocuments'}
                title={this.props.sharedAttachObj.isOrderAttachBatch ? this.translate('Label_Attach_Files_To_Batch') : this.translate('Label_Attach_Files')}
                width={800}
                height={800}
                class='attachDocuments'
                onCloseFunc={this.props.onClose}
                customClass={'wms-model-new-ui-wrapper'}
                isOpen={this.props.isOpenAttachDoc}
                onOpenFunc={this.onOpenModelFunc}
                actions={[]}
                isDefaultMaximise={this.props.isDefaultMaximise}>
                <div className='model-content-wrapper'>
                    {(this.props.sharedAttachObj.isReceipt || this.props.sharedAttachObj.isInventory || this.props.sharedAttachObj.isOrder || this.props.sharedAttachObj.isAssembly) && (
                        <div className="attach-file-detail">
                            <div className="detail-label-wrapper">
                                <label >
                                    {this.translate('Settings_Label_Custom_Customer')}
                                </label>
                                <label >
                                    {this.translate('Orders_Lbl_Transaction_Id')}
                                </label>
                            </div>
                            <div className="detail-value-wrapper">
                                <span>
                                    {this.props.sharedAttachObj.customer}
                                </span>
                                <span>
                                    {this.props.sharedAttachObj.transactionId}
                                </span>
                            </div>
                        </div>
                    )}
                    <div className="attach-modal-file-detail-wrapper">
                        <WmsCollapse
                            id={'attachFilesAddDelete'}
                            headerLabel={this.translate('Label_Add_Delete_Header')}
                            showCollapseText={false}
                            showCollapseIcon={false}>
                            <div className="drag-drop-here-message-area">
                                <div className="drag-drop-here-message">
                                    {this.translate('Label_Drag_Drop_Here_Message')}
                                </div>
                            </div>

                            {this.props.isDragAndDrop && (
                                <div id="dropzone" className="dropzone-overlay">
                                    <div className="dropzone-content">
                                        <i className="fa fa-cloud-upload"></i>
                                        <p>{this.translate('Label_Drop_Files_Here')}</p>
                                    </div>
                                </div>
                            )}
                            {this.props.sharedAttachObj.isOrderAttachBatch && (
                                <div className="customer-batch-wrapper">
                                    <WmsDropdown
                                        id="Customer"
                                        name="selectedCustomerId"
                                        label={this.customLabels.Label_Customer}
                                        wmsSelector={"attachDocCustomer"}
                                        value={this.state.selectedCustomerId}
                                        onChangeFunc={this.handleOptionsChange}
                                        options={this.state.optionsCustomer}
                                        textField='name'
                                        valueField='id'
                                    />
                                    <WmsDropdownList
                                        key={'DropdownlistCustomerBatches'+this.state.selectedCustomerId}
                                        id="DropdownlistCustomerBatches"
                                        name="batchOrderid"
                                        label={this.translate('Label_Batching')}
                                        optionsLabel={this.translate('Label_Choose_Batch')}
                                        wmsSelector={"attachDocCustomerBatches"}
                                        value={this.state.batchOrderid}
                                        onChangeFunc={this.handleOptionsChange}
                                        textField='Description'
                                        valueField='BatchOrderId'
                                        template={"<span class='templtehere' style='white-space: nowrap;text-overflow: ellipsis;display: block;overflow: hidden'>(${ BatchOrderId }) ${  (Description != null) ? Description : ''  }</span>"}
                                        valueTemplate={"<span class='templtehere' style='white-space: nowrap;text-overflow: ellipsis;display: block;overflow: hidden'>(${ BatchOrderId }) ${  (Description != null) ? Description : '' }</span>"}
                                        onDataBound={this.batchOptionBound}
                                        isValuePrimitive={true}
                                        virtualObj={{
                                            itemHeight: 26,
                                            valueMapper: (options) => {
                                                var that = options;

                                                $.ajax({
                                                    url: "/WebUI/Shipping/FindOrders/BatchListForCustomerIndexRead",
                                                    type: "POST",
                                                    dataType: "json",
                                                    data: {
                                                        batchOrderId: that.value || 0,
                                                        customerId: parseInt(selectedCustomerId)
                                                    },
                                                    success: function (data) {
                                                        console.log('dropdownlist', data);
                                                        options.success(data);
                                                    }
                                                });
                                            }
                                        }}
                                        dataSourceObj={{
                                            pageSize: 40,
                                            serverPaging: true,
                                            serverFiltering: true,
                                            type: "aspnetmvc-ajax",
                                            transport: {
                                                read: {
                                                    url: "/WebUI/Shipping/FindOrders/BatchListForCustomerRead",
                                                    type: "POST",
                                                    data: {
                                                        customerId: parseInt(selectedCustomerId)
                                                    }
                                                },
                                            },
                                            schema: {
                                                data: "Data",
                                                total: "Total"
                                            }
                                        }}
                                    />
                                </div>
                            )}
                            <div className="btn-wrapper">
                                <WmsFile
                                    id="label-add-file"
                                    name="label-add-file"
                                    label={this.translate('Label_Add_File')}
                                    wmsSelector="attachDocFiles"
                                    fileProcessType="FileSelect"
                                    value={this.state.selectedFileData.fileName}
                                    onChangeFunc={this.handleFileChange}
                                    disabled={this.props.sharedAttachObj.isOrderAttachBatch && !(this.state.selectedCustomerId && this.state.batchOrderid)}
                                    icon="fa-plus"
                                    showSelectedFileName={false}
                                    clearInputOnClick={true}
                                    loading={this.state.gifAttachFile}
                                    multiple={true}
                                />
                                <WmsButton
                                    label={this.translate('Label_Remove_Attach_Files')}
                                    wmsSelector={"removeAttachDoc"}
                                    onClickFunc={this.eventClickRemoveDoc}
                                    disabled={this.state.selectedFile == 0 || this.state.selectedFile > 1 || this.state.acticveDoc == false || (this.props.sharedAttachObj.isOrder && this.props.sharedAttachObj.selectedOrderData.IsClosed)}
                                    loading={this.state.gifRemoveFile}
                                    showToolTip={this.state.selectedFile == 0 || this.state.selectedFile > 1 || this.state.acticveDoc == false || (this.props.sharedAttachObj.isOrder && this.props.sharedAttachObj.selectedOrderData.IsClosed)}
                                    tooltipText={
                                        this.state.selectedFile == 0 ?
                                            this.translate('Label_Select_Attach_Files') :
                                            (this.state.selectedFile > 1 ?
                                                this.translate('Label_Multiple_Files_Tooltip') :
                                                (
                                                    this.state.acticveDoc == false ?
                                                        this.translate('Label_Select_Removed_Files') :
                                                        this.translate('Label_Remove_Attach_Files_From_Closed_Order')
                                                )
                                            )
                                    }
                                    icon={'fa-trash'}
                                    buttonType="red"
                                />
                            </div>
                            <WmsFormGrid
                                id={this.props.windowId + 'gridAttachedDocs'}
                                wmsSelector={'gridAttachedDocs'}
                                gridKeySelection={'DocName'}
                                columns={this.state.gridColumns}
                                staticGridData={this.state.atttachGridData}
                                schema={this.state.gridSchema}
                                isColumnsResizable={true}
                                isColumnsReorderable={true}
                                isColumnMenuenable={false}
                                isColumnsSortable={true}
                                parentClassName={'showHeader'}
                                showResetMenu={false}
                                onSelection={this.selectAttachGrid}
                                IsMultipleSelectable={true}
                            />
                        </WmsCollapse>
                        {this.props.isHaveImagePreview && (
                            <div id={this.props.windowId + "image-preview-wrapper"} className="image-preview-wrapper">
                                {this.props.isHaveMagnifyImage ? (
                                    <MagnifyImage
                                        imageUrl={this.state.selectedImage || "assets/images/Default_image.png"}
                                        magnifiedImageProps={{
                                            position: "left",
                                        }}
                                    />
                                ) : (
                                    <img
                                        src={this.state.selectedImage || "assets/images/Default_image.png"}
                                        alt="Preview of file" />
                                )}
                                {this.state.selectedImage == null && <span className="no-image-preview-message">No file preview available</span>}
                            </div>
                        )}
                    </div>
                </div>

                <div className="footer-btn-holder">
                    <WmsButton
                        label={this.translate('Label_Close')}
                        wmsSelector={"shipAndcloseCancel"}
                        onClickFunc={this.props.onClose}
                        disabled={false}
                        loading={false}
                        buttonType='orange'
                        icon={'fa-times-circle-o'}
                    />
                </div>


            </WmsModel>
        );
    }
}